<template>
    <div class="form-group--border">
        <div class="scrollable-content">
          <template v-if="page?.items?.length">
            <table class="table-custom ">
              <thead>
                <tr>
                  <th width="10%">№ карты</th>
                  <th width="10%">№ ИППСУ</th>
                  <th>Дата составления</th>
                  <th>Срок действия</th>
                  <th>Форма социального обслуживания</th>
                  <th>Статус</th>
                  <th width="5%"></th>
                  <th width="5%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in page.items" :key="item.id" v-on:dblclick="editCard(item.id)">
                  <td>{{ item.num }}</td>
                  <td>{{ item.ippsuNumber }}</td>
                  <td>{{ $momentFormat(item.date, "DD.MM.YYYY") }}</td>
                  <td>{{ item.journalIppsuServices.length ? $momentFormat(item.journalIppsuServices[0].endDate, "DD.MM.YYYY") : "" }}</td>
                  <td>{{ item.journalIppsuServices.map(x => x.socialTypeInfo ).filter((v, i, a) => a.indexOf(v) === i).join(', ') }}</td>
                  <td>
                    {{ item.statusString == "" ? "Без статуса" : item.statusString }}
                  </td>
                  <td class="ippsu_action-cell" v-on:click="viewCard(item.id)">
                    <icon-component class="ippsu_action-item" name="eye" />
                  </td>
                  <td class="ippsu_action-cell" v-on:click="editCard(item.id)">
                    <icon-component class="ippsu_action-item" name="pen" />
                  </td>
                </tr>
              </tbody>
            </table> 
            
            <div v-if="page.pagesTotal > 1" class="mt-4">
              <Pagination :page-count="page.pagesTotal" :current-page="page.pageNumber" @change="onPageChange($event)"/>
            </div>
            <div>
              <PageCounter :isFiltered="false" :totalCount="totalCount" :filteredCount="page.itemsTotal" />
            </div>
          </template>
        </div>
        <div>
            <div class="float-right d-flex align-items-center mt-4">
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Закрыть</button-component>
            </div>
        </div>
    </div>
</template>

<script>
  import ButtonComponent from "@/common/ui/ButtonComponent";
  import PageCounter from "@/common/components/PageCounter";
  import IconComponent from "@/common/ui/IconComponent";
  import Api from "../api/ippsu";
  export default {
    name: "IppsuModalCard",
    components: {ButtonComponent, PageCounter, IconComponent},
    props: {
      journalId: {
        type: Number
      },
      patientId: {
        type: Number
      }      
    },
    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: 5
        },
        page: {}
      };
    },
    created() {
      console.log(this.journalId);
      const self = this;
      Api.search(Object.assign({ pageNumber: 1, pageSize: 1 }, { journalId: self.journalId })).then(function (response) {      
        console.log(response.data);
        self.totalCount = response.data.itemsTotal;
      });
      this.loadIppsu();
    },
    methods: {
      close() {
        this.$emit('close');
      },
      loadIppsu() {
        const vm = this;
        let params = Object.assign({}, { journalId: this.journalId }, this.request);
        Api.search(params).then(function (response) {
          vm.page = response.data;
        });
      },
      onPageChange(pageNumber) {
        this.request.pageNumber = pageNumber;
        this.loadIppsu()
      },
      viewCard(id) {
        this.$router.push({ name: "ippsuCard", params: { patient_id: this.patientId, action: 'view', id: id } });
      },
      editCard(id) {
        this.$router.push({name: "ippsuCard", params: {patient_id: this.patientId, action: 'edit', id: id}});        
      },
    }
  }
</script>

<style lang="scss" scoped>
    .scrollable-content {
        overflow-y: auto;
        max-height: calc(100vh - 250px);
    }
    .pmpk-view {
        max-width: 98%;
    }
    .ippsu {
      &_action-item {
        color: #ABABB3;
      }
      &_action-cell {
        cursor: pointer;
      }
    }
</style>